import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ptbr',
    debug: false,  // deixe false em produção
    ns: ['header', 'budget', 'footer', 'resume', 'notfound', 'register', 'home', 'services', 'about', 'terms', 'policy', 'whatsapp'],
    defaultNS: 'header',
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/i18n/{{ns}}/{{lng}}.json'
    }
  });

export default i18n;
